/* eslint-disable import/no-extraneous-dependencies */
import { initializeApp } from 'firebase/app';
import { getRemoteConfig, getString } from 'firebase/remote-config';

const firebaseConfig = JSON.parse(process.env.VUE_APP_FIREBASE_CONFIG);

const app = initializeApp(firebaseConfig);
const remoteConfig = getRemoteConfig(app);
remoteConfig.defaultConfig = { IAB_promotion_period_in_months: 3 };

export default function getValue(key) {
  return getString(remoteConfig, key);
}
